import { FormikProvider, useFormik } from "formik";
import { SuitableRenter } from "./fields/SuitableRenterFormik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { ILoanRequest } from "@/types/loan.type";
import { useEffect, useState } from "react";
import { PaymentInfo } from "@/types/payment.type";
import { getSuitablePayments } from "@/common/services/loans.api";
import { PaymentFormikRenter } from "./fields/TableRenterPayments";
import LoanRateCalculator from "../helpers/loanRateCalculator";

type FormPropsLoan = {
  onSubmit: (data: ILoanRequest) => void;
};

export function FormCreateLoan({ onSubmit }: FormPropsLoan) {
  const [allPayments, setAllPayments] = useState<PaymentInfo[]>([]);

  const initialValues = {
    renterInfo: {
      renterName: "",
      renterId: ""
    },
    paymentInfo: {
      externalPaymentsIds: [],
      ids: [],
      totalValue: 0
    },
    loanCalculation: {
      
      principalValue: 0,           
      weeklyRate: 0.05556,        
      paymentAmount: 0,           

      
      numberOfWeeks: 0,           
      numberOfWeeksRounded: 0,    
      totalAmount: 0,             
      totalInterest: 0,           
      totalToPrincipalRatio: 0,   

      
      ruleApplied: "standard" as const,    
      monthlyEquivalentRate: 0,   
      annualEquivalentRate: 0,    

      calculatedAt: null as Date | null,
      isCalculationValid: false
    }
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      await onSubmit(values as ILoanRequest);
    }
  })

  useEffect(() => {
    const fetchPayments = async () => {
      
      if (!formik?.values?.renterInfo?.renterId) {
        setAllPayments([]);
        
        formik.setFieldValue('paymentInfo', {
          externalPaymentsIds: [],
          ids: [],
          totalValue: 0
        });
        return;
      }

      try {
        
        setAllPayments([]);
        formik.setFieldValue('paymentInfo', {
          externalPaymentsIds: [],
          ids: [],
          totalValue: 0
        });

        const response = await getSuitablePayments(formik?.values?.renterInfo?.renterId);

        if (response.ok && response.data) {
          setAllPayments(response.data);
        }
      } catch (error) {
        console.error('Erro ao buscar pagamentos:', error);
        setAllPayments([]);
        
        formik.setFieldValue('paymentInfo', {
          externalPaymentsIds: [],
          ids: [],
          totalValue: 0
        });
      }
    };

    fetchPayments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values?.renterInfo?.renterId]); 

  return (
    <form onSubmit={formik.handleSubmit} className='form-edit'>
      <FormikProvider value={formik}>
        <div className="grid grid-cols-1" style={{ minHeight: "300px" }}>
          <SuitableRenter />
          {(formik.values.renterInfo && formik.values.renterInfo.renterId) && (
            <>
              <PaymentFormikRenter
                key={formik.values.renterInfo.renterId}
                payments={allPayments}
              />
            </>
          )}
          {formik.values.paymentInfo?.totalValue > 1000 && (
            <div className="mt-4">
              <LoanRateCalculator
                key={`${formik.values.renterInfo.renterId}-${formik.values.paymentInfo.totalValue}`}
                totalValue={Number(formik.values.paymentInfo.totalValue.toFixed(2))}
              />
            </div>
          )}
        </div>
        <div className="mt-2 w-full flex justify-end">
          <ButtonWithLoader
            isLoading={formik.isSubmitting}
            onClick={() => formik.submitForm()}
            disabled={formik.isSubmitting}
          >
            Salvar
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  )
}